import { render, staticRenderFns } from "./SkillLevel.vue?vue&type=template&id=098cf538&scoped=true&slot=popover"
import script from "./SkillLevel.vue?vue&type=script&lang=js"
export * from "./SkillLevel.vue?vue&type=script&lang=js"
import style0 from "./SkillLevel.vue?vue&type=style&index=0&id=098cf538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098cf538",
  null
  
)

export default component.exports